import {
  BILLING_ALL,
  BILLING_GET,
  BILLING_DEL,
  BILLING_PUT,
  BILLING_POST,
  BILLING_LOADING,
  BILLING_ERROR,
  BILLING_RESET,
} from '../../actions/types';

const initialState = {
  billing: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case BILLING_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case BILLING_GET:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case BILLING_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case BILLING_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case BILLING_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case BILLING_RESET:
      return { BILLING: null, isLoading: true, isCompleted: true };
    case BILLING_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case BILLING_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
